import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import {
  requestProductInfo,
  requestProductUpdate,
  requestProductDelete,
} from 'requests/products'
import { PRODUCTS } from 'constants/app-paths'
import { productInfo } from 'config/submenus/product'
import { InfoPage } from 'templates/InfoPage'
import { Form } from 'components/Product/Form'
import { SideMenu } from 'components/SideMenu'
import { SlideDialog } from 'ui-components/SlideDialog'
import { ProgressBar } from 'ui-components/ProgressBar'
import { Confirm } from 'ui-components/Confirm'
import { ErrorMessage } from './components/ErrorMessage'
import { BasicInfo } from './components/BasicInfo'
import { StockInfo } from './components/StockInfo'
import {
  InfoCards,
} from './styles'

export default function ProductInfo() {
  const [product, setProduct] = useState({})
  const [responseError, setResponseError] = useState({})
  const [toEdit, setToEdit] = useState(false)
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [deleting, setDeleting] = useState(false)

  const { id } = useParams()
  const history = useHistory()

  const getProduct = useCallback(async () => {
    setLoading(true)
    const response = await requestProductInfo(id)

    setLoading(false)
    if (response.error) {
      return setResponseError(response)
    }

    return setProduct(response.data)
  }, [id])

  useEffect(() => {
    getProduct()
  }, [getProduct])

  const onCancelEdit = () => {
    setToEdit(false)
    setResponseError({})
  }

  const onSave = async (params) => {
    setSaving(true)
    setResponseError({})
    const response = await requestProductUpdate(product.id, params)

    setSaving(false)
    if (response.error) return setResponseError(response)

    setToEdit(false)
    return setProduct({ ...response.data })
  }

  const onDelete = async () => {
    setDeleting(true)
    setResponseError({})
    const response = await requestProductDelete(product.id)

    setDeleting(false)
    if (response.error) return setResponseError(response)

    return history.push(PRODUCTS)
  }

  const renderErrorMessage = () => (
    <ErrorMessage responseError={responseError.message} />
  )

  const renderConfirmDelete = () => (
    <Confirm
      open={confirmDelete}
      title="Deseja remover este produto?"
      onCancel={() => setConfirmDelete(false)}
      type="warning"
      confirmButtonText="Remover"
      onConfirm={onDelete}
      requesting={deleting}
    >
      <div>
        Este registro não poderá ser recuperado.
      </div>
    </Confirm>
  )

  const renderProduct = () => (
    <InfoCards>
      <BasicInfo product={product} />
      <StockInfo product={product} />
    </InfoCards>
  )

  const renderMenu = () => (
    <SideMenu submenu={productInfo(product.id)} />
  )

  return product?.id ? (
    <InfoPage
      renderMenu={renderMenu}
      title={product.attributes.name}
      subtitle="Informações do produto"
      onEdit={() => setToEdit(true)}
      onDelete={() => setConfirmDelete(true)}
    >
      <ProgressBar start={saving || loading || deleting} />

      { renderConfirmDelete() }

      <SlideDialog open={toEdit} onClose={() => setToEdit(false)}>
        <Form
          product={product}
          onCancel={onCancelEdit}
          onSave={onSave}
          responseError={responseError}
          saving={saving}
        />
      </SlideDialog>
      { product?.attributes ? renderProduct() : null }
      { responseError.error ? renderErrorMessage() : null }
    </InfoPage>
  ) : null
}
